var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stats-list"},[_c('div',{staticClass:"stats-data"},_vm._l((_vm.statsData),function(data){return _c('StatsItem',{key:data.name,staticClass:"stats-data__item",attrs:{"data":data}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }